import OBase from './OBase';
import * as Geometry from '../geometry';

export default class ConstructDomain extends OBase {
  update () {
    let aVal = this.getFloatInput('Domain start');
    let bVal = this.getFloatInput('Domain end');

    let output = this.getGenericObjectOutput('Domain');

    let dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(aVal, bVal);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let outTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let start = outDataTrees[0].branches[i][j];
        let end = outDataTrees[1].branches[i][j];
        let interval = new Geometry.Interval(start, end);
        outTree.add(interval, outDataTrees[0].paths[i]);
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ConstructDomain.js